import Footer from "../components/Footer";
import Header from "../components/Header";
import { ArrowDownOnSquareIcon } from "@heroicons/react/24/outline";

export default function Article() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow h-full justify-center items-center flex ">
        <div className="flex flex-col sm:flex-row justify-center place-items-center ">
          <div className="w-2/2 px-5 sm:px-0 ">
            <table
              style={{
                fontFamily: "arial, sans-serif",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#dddddd" }}>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                      padding: "8px",
                    }}
                  >
                    Year
                  </th>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                      padding: "8px",
                    }}
                  >
                    Volume
                  </th>
                  <th
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                      padding: "8px",
                    }}
                  >
                    Open
                  </th>
                </tr>
              </thead>
              <tbody>

                 <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2026
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume IX, Issue 1
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2026i1">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2025
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume VIII, Issue 2
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2025i2">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                   <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2025
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume VIII, Issue 1
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2025">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                   <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2023
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                  	Volume VI, Issue 1 & 2
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2023">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2022
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume V, Issue 1 & 2
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2022">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2021
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume IV, Issue 1 & 2
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2021">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2020
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume III, Issue 1
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2020">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2019
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-52 pl-2"
                  >
                    Volume II, Issue 2
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2019v2">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2019
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-72 pl-2"
                  >
                    Volume II, Issue 1
                  </td>

                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2019">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-16 pl-2"
                  >
                    2018
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "left",
                    }}
                    className="w-52 pl-2"
                  >
                   Volume I, Issue 2
                  </td>
                  <td
                    style={{
                      border: "1px solid #dddddd",
                      textAlign: "center",
                      padding: "8px",
                    }}
                    className=" justify-center items-center flex"
                  >
                    <a href="/2018">
                      <ArrowDownOnSquareIcon
                        aria-hidden="true"
                        className="size-6"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className=" ml-4 mt-10 mb-10 sm:mb-0 sm:mt-0">
            <img className="h-72 w-48" src="mea.webp" alt="Mizoram Economic Review Cover"/>
            <div className="text-sm font-semibold pt-2 text-center">
              ISSN 2581-7523
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
